import { ProjectReportField } from "./projectReportField";

type ProjectReportTemplate = {
  name: string;
  indicators: ProjectReportField[];
  textFields: ProjectReportField[];
};

const projectReportTemplate: ProjectReportTemplate = {
  name: "",
  indicators: [],
  textFields: [],
};

export type { ProjectReportTemplate };

export { projectReportTemplate };
